import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshButton } from 'components/RefreshButton';

export interface RefreshTenantListButtonProps {
  onRefresh: () => void;
  loading?: boolean;
}

export const RefreshTenantListButton: React.FunctionComponent<RefreshTenantListButtonProps> = ({
  onRefresh,
  loading,
}) => {
  const { t } = useTranslation();
  return <RefreshButton onRefresh={onRefresh} loading={loading} label={t('tenantList.refresh')} />;
};
